// Validação de arquivos anexados.
// A validação é feita pela EXTENSÃO: o `file.type` informado pelo navegador varia por sistema
// (ex.: o Windows informa "application/x-zip-compressed" para .zip, outros vazio).

export type CategoriaArquivo = 'evidencia' | 'script_banco';

export const EXTENSOES_PERMITIDAS: Record<CategoriaArquivo, string[]> = {
  evidencia: [
    '.pdf',
    '.doc',
    '.docx',
    '.xls',
    '.xlsx',
    '.txt',
    '.csv',
    '.zip',
    '.rar',
    '.jpg',
    '.jpeg',
    '.png',
    '.gif',
  ],
  script_banco: ['.sql', '.zip', '.rar', '.7z', '.txt'],
};

export const TAMANHO_MAXIMO_MB = 10;

export const extensaoDoArquivo = (nome: string): string => {
  const indice = nome.lastIndexOf('.');
  return indice >= 0 ? nome.substring(indice).toLowerCase() : '';
};

export const rotuloExtensoes = (extensoes: string[]): string =>
  extensoes.map(extensao => extensao.replace('.', '').toUpperCase()).join(', ');

/** Retorna a mensagem de erro, ou null quando o arquivo é aceito. */
export const validarArquivo = (
  file: File,
  extensoes: string[],
  tamanhoMaximoMB: number = TAMANHO_MAXIMO_MB
): string | null => {
  if (file.size > tamanhoMaximoMB * 1024 * 1024) {
    return `Arquivo ${file.name} é muito grande. Máximo: ${tamanhoMaximoMB}MB`;
  }
  if (!extensoes.includes(extensaoDoArquivo(file.name))) {
    return `Tipo de arquivo não suportado: ${file.name}. Permitidos: ${rotuloExtensoes(extensoes)}`;
  }
  return null;
};
